// Supabase project — assets CDN + direct form submissions.
// The anon key is safe to ship in the frontend: row-level-security policies
// only allow inserting contact/career rows and reading service videos.
export const SUPABASE_URL = "https://ssndbleyoaintnvgaxbs.supabase.co";
export const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNzbmRibGV5b2FpbnRudmdheGJzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMxMDM5OTIsImV4cCI6MjA5ODY3OTk5Mn0.lnMDtWaDHtW5vrLdlZkSy5hneDLg_i7WMBEj8GOL9io";

// Site images/videos are served from our own server (public/assets — same
// domain, no extra DNS/TLS hop, long-cache). The same files also exist in the
// Supabase "assets" bucket as a backup.
export const asset = (path) => `/assets/${path}`;

const headers = {
  apikey: SUPABASE_ANON_KEY,
  Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
  "Content-Type": "application/json",
};

// Insert a row (used by the contact + careers forms when the backend
// API is unreachable, e.g. on static hosting).
export async function sbInsert(table, row) {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}`, {
    method: "POST",
    headers: { ...headers, Prefer: "return=minimal" },
    body: JSON.stringify(row),
  });
  if (!res.ok) throw new Error(`Supabase insert failed: ${res.status}`);
}

// Read rows with simple equality filters, newest first.
export async function sbSelect(table, filters = {}) {
  const params = new URLSearchParams({ select: "*", order: "created_at.desc" });
  for (const [k, v] of Object.entries(filters)) params.set(k, `eq.${v}`);
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}?${params}`, { headers });
  if (!res.ok) throw new Error(`Supabase select failed: ${res.status}`);
  return res.json();
}
